import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import { defineState } from 'redux-localstore';

const defaultState = {
  declineOpportunity: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('declineOpportunity');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.declineOpportunity.length > 0 ? action.declineOpportunity : [];
  return updateObject(state, {
    declineOpportunity: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, declineOpportunity: [] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DECLINE_OPPORTUNITY_START:
      return fetchStart(state);
    case actionTypes.FETCH_DECLINE_OPPORTUNITY_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_DECLINE_OPPORTUNITY_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;
